import { r as react, j as jsxRuntime, e as reactDom } from './injectIntl-6b03af4d.js';
import { u as useForkRef, s as setRef } from './useIsFocusVisible-2f9a9c23.js';
import { a as useEnhancedEffect } from './useEventCallback-b1ea57d1.js';

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/base-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/base-ui/react-portal/components-api/#portal)
 */
const Portal = /*#__PURE__*/react.exports.forwardRef(function Portal(props, forwardedRef) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = react.exports.useState(null);
  // @ts-expect-error TODO upstream fix
  const handleRef = useForkRef( /*#__PURE__*/react.exports.isValidElement(children) ? children.ref : null, forwardedRef);
  useEnhancedEffect(() => {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(() => {
    if (mountNode && !disablePortal) {
      setRef(forwardedRef, mountNode);
      return () => {
        setRef(forwardedRef, null);
      };
    }
    return undefined;
  }, [forwardedRef, mountNode, disablePortal]);
  if (disablePortal) {
    if ( /*#__PURE__*/react.exports.isValidElement(children)) {
      const newProps = {
        ref: handleRef
      };
      return /*#__PURE__*/react.exports.cloneElement(children, newProps);
    }
    return /*#__PURE__*/jsxRuntime.exports.jsx(react.exports.Fragment, {
      children: children
    });
  }
  return /*#__PURE__*/jsxRuntime.exports.jsx(react.exports.Fragment, {
    children: mountNode ? /*#__PURE__*/reactDom.exports.createPortal(children, mountNode) : mountNode
  });
});

export { Portal as P };

//# sourceMappingURL=Portal-a10cce0f.js.map